export function markStatusTooltip(isMarkFinished: boolean): string {
  return (
    `Mark has ${isMarkFinished ? 'a finished' : 'an unfinished'} status which ` +
    `${isMarkFinished ? 'is preventing' : "isn't preventing"} the response from being force ` +
    `reallocated. ${isMarkFinished ? 'Reallocation requires a draft mark status.' : ''}`
  );
}

export function activeMarkerTooltip(
  markerIsActiveMarker: boolean,
  activeMarkerName: string,
  isMark: boolean
): string {
  const message = markerIsActiveMarker
    ? `must be ${isMark ? 'reassigned to another marker or deleted' : 'rescored or unscored'} to ` +
      `successfully deallocate ${activeMarkerName} from the response.`
    : `does not need to be reassigned from ${activeMarkerName} to proceed with deallocation.`;
  return `${isMark ? 'Mark ' : 'Mark item'} ${message}`;
}
